var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"default-color-statue",class:{
    'black-color-statue': _vm.item.etat == 'Créé',
    'green-color': _vm.item.etat == 'Payé',
    'red-color montant-bare': _vm.item.etat == 'Annulée',
    'color-som-text': _vm.item.type === 'separation'
  }},[_c('editable-input-frais-unite-th',{attrs:{"editable":_vm.editable,"champName":_vm.column,"item":_vm.item,"value":_vm.item[_vm.column],"type":"text","updateFunction":_vm.updateFunction,"valueToShow":_vm.coef == true ? _vm.columnCoef : _vm.showCoef == true ? _vm.columnCoef : _vm.column,"showIconEdit":true,"showBlock":_vm.showBlock,"uniteMontant":_vm.uniteMontant}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }